import { ExtensionInfo } from 'hooks/embedded-status/useEmbeddedStatusSwr';
import { useTranslation } from 'react-i18next';
import { hasThankYouPage } from '../../integrationStatusUtils';
import { SettingsWrapper } from '../../../settings-wrapper/SettingsWrapper';

export const ThankYouPageIntegration = ({
    thankYouPageIntegration,
    isLoading,
    condensed,
    handleClickAddStoreAppBlock,
}: ThankYouPageIntegrationProps) => {
    const { t } = useTranslation();

    const handleAddStoreAppBlock = () => {
        open(`shopify://admin/settings/checkout/editor?page=thank-you&context=apps`, '_blank');
        handleClickAddStoreAppBlock?.();
    };

    const hasThankYouPageIntegration = hasThankYouPage(thankYouPageIntegration);

    return (
        <SettingsWrapper
            title={t('DASHBOARD.APP_EXTENSIONS.THANK_YOU_PAGE_INTEGRATION.TITLE')}
            badge={
                <s-badge tone={hasThankYouPageIntegration ? 'success' : undefined}>
                    {hasThankYouPageIntegration
                        ? t('DASHBOARD.APP_EXTENSIONS.ACTIVE')
                        : t('DASHBOARD.APP_EXTENSIONS.INACTIVE')}
                </s-badge>
            }
            description={
                hasThankYouPageIntegration
                    ? t('DASHBOARD.APP_EXTENSIONS.THANK_YOU_PAGE_INTEGRATION.ACTIVE')
                    : t('DASHBOARD.APP_EXTENSIONS.THANK_YOU_PAGE_INTEGRATION.INACTIVE')
            }
            actions={
                <s-button variant="secondary" onClick={handleAddStoreAppBlock}>
                    {t('DASHBOARD.APP_EXTENSIONS.THANK_YOU_PAGE_INTEGRATION.ACTIONS.ADD_THANK_YOU_PAGE')}
                </s-button>
            }
            isLoading={isLoading}
            condensed={condensed}
        />
    );
};

interface ThankYouPageIntegrationProps {
    thankYouPageIntegration: ExtensionInfo;
    isLoading: boolean;
    condensed?: boolean;
    handleClickAddStoreAppBlock?: () => void;
}
